export function UsersIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1829_7550)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.2266 17.5059C24.0532 18.7459 25.3332 20.4259 25.3332 22.6659V26.6659H30.6666V22.6659C30.6666 19.7592 25.9066 18.0392 22.2266 17.5059Z"
          fill="currentColor"
        />
        <path
          d="M12.0001 16.0007C14.9456 16.0007 17.3334 13.6128 17.3334 10.6673C17.3334 7.7218 14.9456 5.33398 12.0001 5.33398C9.05456 5.33398 6.66675 7.7218 6.66675 10.6673C6.66675 13.6128 9.05456 16.0007 12.0001 16.0007Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9999 16.0007C22.9466 16.0007 25.3333 13.614 25.3333 10.6673C25.3333 7.72065 22.9466 5.33398 19.9999 5.33398C19.3733 5.33398 18.7866 5.46732 18.2266 5.65398C19.3739 7.07294 19.9999 8.84252 19.9999 10.6673C19.9999 12.4921 19.3739 14.2617 18.2266 15.6807C18.7866 15.8673 19.3733 16.0007 19.9999 16.0007ZM11.9999 17.334C8.43992 17.334 1.33325 19.1207 1.33325 22.6673V26.6673H22.6666V22.6673C22.6666 19.1207 15.5599 17.334 11.9999 17.334Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1829_7550">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
